module.exports = __webpack_public_path__ + "static/img/6-info.4692cf7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/layer4/6-info.png
// module id = gp15
// module chunks = 0